/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Converter_Solve_ForInputs */

const en_ui_labs_converter_solve_for = /** @type {(inputs: Ui_Labs_Converter_Solve_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solve for`)
};

const de_ui_labs_converter_solve_for = /** @type {(inputs: Ui_Labs_Converter_Solve_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne`)
};

/**
* | output |
* | --- |
* | "Solve for" |
*
* @param {Ui_Labs_Converter_Solve_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_converter_solve_for = /** @type {((inputs?: Ui_Labs_Converter_Solve_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Converter_Solve_ForInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_converter_solve_for(inputs)
	return de_ui_labs_converter_solve_for(inputs)
});